import { connect } from 'react-redux';
import { toggleMenu } from '../store/actions';
import App from '../components/App';

function mapStateToProps(state) {
    const { isMenuExpanded } = state.uiState;
    return {
        isMenuExpanded
    }
}

function mapDispatchToProps(dispatch) {
    return {
        toggleMenu: state => dispatch(toggleMenu(state))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);


// WEBPACK FOOTER //
// ./src/containers/App.js